<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@visibility="visibility"
			@edit="edit"
			@add="add"
			@search="search">
		</fab>

		<add ref="add" :user="user" :isAuth="isAuth" :data="data" @reload="reload"></add>
		<search ref="search" :user="user" :isAuth="isAuth" @reload="reload"></search>
	</div>
</template>

<script>
	import fab from 'vue-fab'
	import Add from './Add'
	import Search from '@/components/search/layout/Search'
	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			fab,
			'add': Add,
			'search': Search,
		},
		created() {
			this.init()
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					fabActions: null,
					tooltip: true,
				}
			}
		},
		methods: {
			init() {
				this.loadActions()
			},
			loadActions() {
				if(this.type == 'show') {
					var actions = [
						{
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}
				if(this.type == 'edit') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}
				if(this.type == 'index') {
					var actions = [
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
					]
				}

				this.fab.fabActions = actions
			},
			edit() {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id + '/edit'
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/customers/' + this.data.id + '/edit'
					}
				} else {
					var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id + '/edit'
				}

				this.$router.push(to)
			},
			visibility() {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/customers/' + this.data.id
					}
				} else {
					var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id
				}

				this.$router.push(to)
			},
			add() {
				if(this.type == 'index') {
					this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/customers/create')
				} else {
					this.$refs.add.open()
				}
			},
			search() {
				this.$refs.search.open('customers')
			},
			reload() {
				this.$emit('reload')
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Fab.vue